import { render, staticRenderFns } from "./PendingApprovalsTable.vue?vue&type=template&id=349f25c1&scoped=true&"
import script from "./PendingApprovalsTable.vue?vue&type=script&setup=true&lang=js&"
export * from "./PendingApprovalsTable.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./PendingApprovalsTable.vue?vue&type=style&index=0&id=349f25c1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349f25c1",
  null
  
)

export default component.exports